/* api接口地址汇总
 * @Author: nowThen
 * @Date: 2019-08-14 16:05:21
 */

export const apiUrl = {
  login: '/api/login',
  loginOut: '/api/loginOut',

  // mock
  qryPageConfig: '/test/pageConfig',

  msg: '/index/securityPolicy',
  // 验证码
  getCaptcha: '/captchaImage',
  // 邮寄车牌信息
  addVehicleInfo: '/post/info/add',
  // 站点信息
  getSite: '/org/info/list'
}
